import fomat from '../../utilities/format.js';
import states from '../glb/data.state.js';
import urlMixin from '../../../common/mixins/url.js';
import { getFormatAddress } from '../../../../widget/spec/geohelper.js';

function capitalize(word) {
    if (!word) {
        return word;
    }
    var words = word.split(' ');
    return words
        .map(function (str) {
            const lower = str.toLowerCase();
            return str.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join(' ');
}

function convertGeoInfo(data) {
    var geoInfo = {};
    if (data.stateCode) {
        geoInfo.state = data.stateCode;
    }
    if (data.location) {
        geoInfo.lat = data.location.lat;
        geoInfo.lng = data.location.lng;
    }
    if (data.type === 'STATE') {
        geoInfo.state = data.displayName;
        geoInfo.stateId = data.id;
    } else if (data.type === 'CITY') {
        geoInfo.city = data.displayName;
        geoInfo.cityId = data.id;
    } else if (data.type === 'COUNTY') {
        geoInfo.county = data.displayName;
        geoInfo.countyId = data.id;
    } else if (data.type === 'POSTAL_CODE') {
        geoInfo.city = data.cityDisplayName;
        geoInfo.zipcode = data.displayName;
        geoInfo.zipcodeId = data.id;
    } else if (data.type === 'NEIGHBORHOOD') {
        geoInfo.city = data.cityDisplayName;
        geoInfo.neighborhood = data.displayName;
        geoInfo.neighborhoodId = data.id;
        geoInfo.neighborhoodPath = data.sitemapNeighborhoodPageUrl;
    } else {
        return data;
    }
    return geoInfo;
}

function getGeoType(data) {
    if (data.address) {
        return 'ADDRESS';
    } else if (data.zipcode) {
        return 'ZIPCODE';
    } else if (data.neighborhood) {
        return 'NEIGHBORHOOD';
    } else if (data.city) {
        return 'CITY';
    } else if (data.county) {
        return 'COUNTY';
    } else if (data.state) {
        return 'STATE';
    }
    return 'GPS';
}

function getGeoId(data, geoType) {
    if (geoType === 'ZIPCODE') {
        return data.zipcodeId;
    } else if (geoType === 'NEIGHBORHOOD') {
        return data.neighborhoodId;
    } else if (geoType === 'CITY') {
        return data.cityId;
    } else if (geoType === 'COUNTY') {
        return data.countyId;
    } else if (geoType === 'STATE') {
        return data.stateId;
    }
    return '';
}

function getGeoName(data, geoType) {
    if (geoType === 'ZIPCODE') {
        return data.zipcode;
    } else if (geoType === 'NEIGHBORHOOD') {
        return data.neighborhood;
    } else if (geoType === 'CITY') {
        return data.city;
    } else if (geoType === 'COUNTY') {
        return data.county;
    } else if (geoType === 'STATE') {
        return data.state;
    }
    return '';
}

const _formatText = function (text) {
    if (!text) {
        return '';
    }
    return text
        .replace(/[^a-zA-Z0-9]+/gi, '-')
        .replace(/-*\/$/, '/')
        .replace(/-$/, '');
};

function initalGeoByUrl(path, rentals) {
    if (!path) {
        return;
    }
    var geo = { hasGeoInfo: false };
    var url = path.replace(/^\//, '');
    url = url.replace(/\/$/, '');
    if (url) {
        var segments = url.split('/');
        var city = /^([a-z\-]+)\-(\w{2})/i.exec(segments[0]);
        if (city) {
            geo.state = city[city.length - 1].toUpperCase();
            geo.stateCode = geo.state.toLowerCase();
            geo.cityCode = city[city.length - 2];
            geo.city = fomat.capitalize(geo.cityCode.replace(/\-/g, ' '));
            if (segments[1]) {
                var address = /^([a-z\-]+)\-(\d{5})/i.exec(segments[1]);
                if (address) {
                    geo.zipcode = address[city.length - 1];
                    geo.address = address[city.length - 2].replace(/\-/g, ' ');
                } else {
                    geo.zipcode = '';
                    geo.address = '';
                }
            } else {
                geo.zipcode = '';
                geo.address = '';
            }
        } else if (/[a-z]{2}/i.test(segments[0])) {
            geo.state = segments[0].toUpperCase();
            geo.stateCode = segments[0].toLowerCase();
            geo.city = '';
            geo.cityCode = '';
            geo.address = '';
            if (/\d{5}/.test(segments[1])) {
                geo.zipcode = segments[1].toLowerCase();
            }
        }
        geo.hasGeoInfo = !!geo.state;
    }
    return geo;
}

export default function (geo, rentals) {
    var data = geo;
    if (!geo) {
        return {
            hasGeoInfo: false,
        };
    } else if (typeof geoInfo === 'string') {
        return initalGeoByUrl(geo);
    } else if (geo.type) {
        //if it soa geo data do mapping
        data = convertGeoInfo(geo);
    }

    let neighborhood;
    let safeToGenerateNeighborhoodPath = false;
    var city = data.city && data.city.toLowerCase();
    //if neighborhood is same as city, then dont use it
    if (data.neighborhoodName) {
        neighborhood = data.neighborhoodName;
        let code = _formatText(data.neighborhoodName);
        if (
            data.neighborhoodName.toLowerCase() !== city &&
            (code === _formatText(data.neighborhoodN) ||
                code === _formatText(data.neighborhoodS) ||
                ['N_NEIGHBORHOOD', 'S_NEIGHBORHOOD'].includes(data.neighborhoodType))
        ) {
            safeToGenerateNeighborhoodPath = true;
        } else {
            data.neighborhoodPath = '';
        }
    } else if (data.neighborhood && data.neighborhood.toLowerCase() !== city) {
        neighborhood = data.neighborhood;
        safeToGenerateNeighborhoodPath = true;
    } else if (data.neighborhoodN && data.neighborhoodN.toLowerCase() !== city) {
        neighborhood = data.neighborhoodN;
        safeToGenerateNeighborhoodPath = true;
    } else if (data.neighborhoodS && data.neighborhoodS.toLowerCase() !== city) {
        neighborhood = data.neighborhoodS;
        safeToGenerateNeighborhoodPath = true;
    } else if (data.neighborhoodM && data.neighborhoodM.toLowerCase() !== city) {
        neighborhood = data.neighborhoodM;
        safeToGenerateNeighborhoodPath = false;
    }

    if (!neighborhood) {
        data.neighborhoodPath = data.sitemapNeighborhoodPageUrl = '';
    }
    var geoInfo = {
        hardcode: data.hardcode || false,
        hasGeoInfo: !!data.state,
        state: data.state ? data.state.toUpperCase() : '',
        stateCode: data.state ? data.state.toLowerCase() : '',
        stateId: data.stateId || '',
        city: data.city ? capitalize(data.city) : '',
        cityCode: data.city ? _formatText(data.city).toLowerCase() : '',
        cityId: data.cityId || '',
        county: data.county ? capitalize(data.county) : '',
        countyId: data.countyId || '',
        countyCode: data.county ? _formatText(data.county).toLowerCase() : '',
        fipsCode: data.fipsCode || '',
        neighborhoodN: data.neighborhoodN || '',
        neighborhoodS: data.neighborhoodS || '',
        neighborhood: neighborhood || '',
        neighborhoodId: data.neighborhoodId || data.neighborhoodNId || data.neighborhoodSId || data.neighborhoodMId || '',
        neighborhoodPath: data.neighborhoodPath || '',
        neighborhoodType: data.neighborhoodType || '',
        neighborhoodCode: neighborhood ? _formatText(neighborhood).toLowerCase() : '',
        zipcode: data.zipcode || '',
        zipcodeId: data.zipcodeId || '',
        address: data.address || '',
        subPremise: data.subPremise || '',
        lat: data.lat || 0,
        lng: data.lng || 0,
        stateFullName: states[data.state] || '',
        extraPath: data.extraPath || '',
    };

    if (safeToGenerateNeighborhoodPath && geoInfo.neighborhoodCode && geoInfo.cityCode && geoInfo.stateCode) {
        geoInfo.neighborhoodPath = `${geoInfo.cityCode}-${geoInfo.stateCode}/${geoInfo.neighborhoodCode}/`;
    }

    geoInfo.formatAddress = getFormatAddress(geoInfo);
    geoInfo.geoType = getGeoType(geoInfo);
    geoInfo.geoId = getGeoId(geoInfo, geoInfo.geoType);
    geoInfo.geoName = getGeoName(geoInfo, geoInfo.geoType);
    geoInfo = Object.assign(geoInfo, urlMixin.methods.generateGeoPaths(geoInfo, { rentals, safeToGenerateNeighborhoodPath: safeToGenerateNeighborhoodPath }));
    return geoInfo;
}
